export default {
  getQueryString: function(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
    var r = window.location.search.substr(1).match(reg) //search,查询？后面的参数，并匹配正则
    if (r != null) return unescape(r[2])
    return null
  },
  getRequest: function() {
    var url = location.search
    var theRequest = new Object()
    if (url.indexOf("?") != -1) {
      var str = url.substr(1)
      var strs = str.split("&")
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1])
      }
    }
    return theRequest
  },
  checkPlatform: function() {
    if (
      /(iPhone|iPad|iPod|iOS|Android|OpenHarmony)/i.test(navigator.userAgent)
    ) {
      return "mobile"
    } else {
      return "pc"
    }
  },
  checkInMiniProgram: function() {
    const ua = navigator.userAgent.toLowerCase()
    return ua.includes("miniprogram")
  },
  getCookie(cname) {
    var name = cname + "="
    var ca = document.cookie.split(";")
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim()
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length)
      }
    }
    return null
  }
}



// WEBPACK FOOTER //
// ./src/common/utils.js